import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import { NotificationProvider } from '@/context/NotificationContext';
import { I18nProvider } from '@/i18n';
import { Toaster } from '@/components/ui/sonner';
import Navbar from '@/components/Navbar';
import GamerTagPrompt from '@/components/GamerTagPrompt';
import ChatDrawer from '@/components/ChatDrawer';
import WelcomeDialog from '@/components/WelcomeDialog';
import { useVisitorTracking } from '@/hooks/useVisitorTracking';
import { useAuth } from '@/context/AuthContext';
import Landing from '@/pages/Landing';
import MapView from '@/pages/MapView';
import Admin from '@/pages/Admin';
import Profile from '@/pages/Profile';
import Convoys from '@/pages/Convoys';
import ConvoyDetail from '@/pages/ConvoyDetail';
import Messages from '@/pages/Messages';
import PublicProfile from '@/pages/PublicProfile';
import Media from '@/pages/Media';
import { setToken } from '@/lib/api';

function AuthFinish() {
  const navigate = useNavigate();
  const location = useLocation();
  React.useEffect(() => {
    const hash = location.hash || '';
    const match = hash.match(/token=([^&]+)/);
    if (match) {
      setToken(decodeURIComponent(match[1]));
    }
    // Force reload to /  so AuthContext re-fetches user
    window.location.replace('/');
  }, [navigate, location]);
  return <div className="min-h-screen grid place-items-center text-white/60">Connexion en cours...</div>;
}

function AnonymousLayer() {
  const { user } = useAuth();
  const isAnon = !user || user === false;
  useVisitorTracking(isAnon);
  return <WelcomeDialog />;
}

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0A0A] text-white">
      <I18nProvider>
        <BrowserRouter>
          <AuthProvider>
            <NotificationProvider>
            <Navbar />
            <GamerTagPrompt />
            <AnonymousLayer />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/maps/:gameId" element={<MapView />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/convoys" element={<Convoys />} />
              <Route path="/convoys/:id" element={<ConvoyDetail />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/u/:userId" element={<PublicProfile />} />
              <Route path="/media" element={<Media />} />
              <Route path="/auth/finish" element={<AuthFinish />} />
            </Routes>
            <ChatDrawer />
            <Toaster
              theme="dark"
              position="bottom-right"
              toastOptions={{
                style: {
                  background: 'rgba(10,10,10,0.95)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  color: '#fff',
                  backdropFilter: 'blur(20px)',
                },
              }}
            />
            </NotificationProvider>
          </AuthProvider>
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}

export default App;
